import React from 'react';
import Title from '../layouts/Title';
import {  pjkone1, pjkone2,pjkone3,pjkone4,pjkone5,pjkone6,pjkone7, pjktwo1,pjktwo10,pjktwo2,pjktwo3,pjktwo4,pjktwo5,pjktwo6,pjktwo7,pjktwo8,pjktwo9, pjktwo11, pjktri1,pjktri2,pjktri3,pjktri4, pjkfor1, pjkfor2, pjkfor3, pjkfor4, pjktfive1,pjktfive2,pjktfive3,pjktfive4,pjktfive5,pjktfive6,pjktfive7,pjktfive8,pjktfive9 } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-14">
        <ProjectsCard
          title={<span style={{ fontWeight: 'bold' }}>Environthink</span>}
          des={
            <>
              <span style={{ color: 'orange' }}>UIUX Figma,Design Thinking, React JS, Bootstrap</span><br />
              <p style={{ textAlign: 'justify' }}><strong>Environthink</strong> adalah sebuah platform yang didedikasikan untuk meningkatkan kesadaran publik terhadap masalah lingkungan dan krisis iklim. Platform ini bertujuan untuk menjadi wadah edukasi, informasi, serta inspirasi bagi individu dan komunitas yang peduli terhadap perlindungan dan pelestarian lingkungan.</p>
              <br /><br />
              Proyek ini mencakup:
              <ul>
                <li>1. Menyajikan infografis mengenai krisis iklim</li>
                <li>2. Menyediakan informasi mengenai krisis iklim dalam bentuk artikel</li>
                <li>3. Membuat website penggalangan dana</li>
                <li>4. Membuat kampanye berupa aksi sosial seperti petisi online</li>
              </ul>
              <br />
              Semua fitur ini dirancang untuk memudahkan pengguna berkontribusi dalam mengurangi dampak krisis iklim dan meningkatkan kesadaran publik.
              </>
            }
          websiteLink="https://environthink.netlify.app/" 
          src={pjkone1}
          gallery={[pjkone2, pjkone1, pjkone3, pjkone4, pjkone5, pjkone6, pjkone7]} // Tambahkan gambar ke carousel
        />

        <ProjectsCard
          title={<span style={{ fontWeight: 'bold' }}>Redesign Aplikasi Pembelian Tiket mTix</span>}
          des={
            <>
              <span style={{ color: 'orange' }}>UIUX Design, Design Thinking</span><br />
              <p style={{ textAlign: 'justify' }}><strong>Aplikasi pembelian tiket mTix </strong> adalah platform yang memudahkan pengguna dalam membeli tiket bioskop secara online. Redesign ini bertujuan untuk meningkatkan pengalaman pengguna dengan tampilan antarmuka yang lebih modern dan intuitif, serta menambahkan fitur-fitur baru yang membuat proses pembelian tiket menjadi lebih cepat dan efisien.</p>
              <br />
              Proyek ini mencakup:
              <ul>
                <li>- Redesign halaman utama aplikasi mTix</li>
                <li>- Perbaikan mengenai fitur-fitur dan perbaikan antarmuka</li>
                <li>- Implementasi proses pembelian tiket dan XII cafe yang lebih cepat dan user-friendly</li>
              </ul>
              <br /><br /><br />
            </>
          }
          // websiteLink="https://www.figma.com/proto/cCxnaJ9tAEXaNPTZ64NB6s/FIX-BJ?node-id=301-37238&node-type=FRAME&t=nIOsR7hj6xIxLBQJ-1&scaling=scale-down&content-scaling=fixed&page-id=301%3A36523&starting-point-node-id=301%3A36524" 
          src={pjktfive9}
          gallery={[pjktfive1, pjktfive2, pjktfive3, pjktfive4, pjktfive5, pjktfive6, pjktfive7, pjktfive8, pjktfive9]} // Tambahkan gambar ke carousel
        />

        <ProjectsCard
          title={<span style={{ fontWeight: 'bold' }}>Landing Page - Office Zone</span>}
          des={
            <>
              <span style={{ color: 'orange' }}>UIUX Figma, React JS, Bootstrap, Restfull API</span><br />
              <p style={{ textAlign: 'justify' }}><strong>OfficeZone </strong>adalah aplikasi berbasis web dan Android yang dirancang untuk memudahkan penyewaan ruang kantor di Jakarta. Selain itu, pengembangan website ini mencakup pembuatan landing page yang menarik dan halaman admin yang fungsional, sehingga dapat memberikan pengalaman pengguna yang aman dan nyaman dalam menemukan ruang kerja yang sesuai di kawasan bisnis Jakarta.</p>
              <br />
              Proyek ini mencakup:
              <ul>
                <li>- Halaman Landing Page website Office Zone</li>
                <li>- Dapat melakukan pencarian Office yang tersedia</li>
                <li>- Untuk pemesanan Office dilakukan dengan halaman android yang dibikin tim develop android</li>
              </ul><br />
            </>
          }
          websiteLink="https://officezone.vercel.app/" 
          src={pjktwo1}
          gallery={[pjktwo11, pjktwo1,pjktwo2, pjktwo3, pjktwo4]} // Tambahkan gambar ke carousel
        />

        <ProjectsCard
          title={<span style={{ fontWeight: 'bold' }}>ADMIN - Office Zone</span>}
          des={
            <>
              <span style={{ color: 'orange' }}>UIUX Figma, React JS, Bootstrap, Restfull API</span><br />
              <p style={{ textAlign: 'justify' }}><strong>OfficeZone </strong>adalah aplikasi berbasis web dan Android yang dirancang untuk memudahkan penyewaan ruang kantor di Jakarta. Selain itu, pengembangan website ini mencakup pembuatan landing page yang menarik dan halaman admin yang fungsional, sehingga dapat memberikan pengalaman pengguna yang aman dan nyaman dalam menemukan ruang kerja yang sesuai di kawasan bisnis Jakarta.</p>
              <br />
              Proyek ini mencakup:
              <ul>
                <li>- Halaman Admin Office Zone</li>
                <li>- Dapat mengelola seluruh data admin, user, building, reservasi, dan payment</li>
                <li>- Dapat mengelola data OfficeZone dengan CRUD</li>
              </ul><br /><br />
            </>
          }
          websiteLink="https://officezone.vercel.app/auth" 
          src={pjktwo5}
          gallery={[ pjktwo5, pjktwo6, pjktwo7, pjktwo8, pjktwo9, pjktwo10]} // Tambahkan gambar ke carousel
        />

        <ProjectsCard
          title={<span style={{ fontWeight: 'bold' }}>Website Day Care Schools</span>}
          des={
            <>
              <span style={{ color: 'orange' }}>React JS, Bootstrap, Restfull API</span><br />
              <p style={{ textAlign: 'justify' }}><strong>Day Care Schools </strong> adalah Website sekolah penitipan anak untuk mencari informasi dan mengetahui lebih lanjut tentang sekolah penitipan anak, serta membantu sekolah penitipan anak dalam mempromosikan layanan mereka, meningkatkan visibilitas mereka di dunia online, serta memfasilitasi proses pendaftaran dan komunikasi antara sekolah penitipan anak dan orang tua.</p>
              <br />
              Proyek ini mencakup:
              <ul>
                <li>- Halaman Landing Page website Day Care Schools</li>
                <li>- Penjelasan mengenai Day Care Schools</li>
                <li>- CRUD pendaftaran student</li>
              </ul>
              
            </>
          }
          websiteLink="https://miniproject-student-app.netlify.app/" 
          src={pjktri1}
          gallery={[pjktri1, pjktri2, pjktri3, pjktri4]} // Tambahkan gambar ke carousel
        />

        <ProjectsCard
          title={<span style={{ fontWeight: 'bold' }}>TODOLIST APP</span>}
          des={
            <>
              <span style={{ color: 'orange' }}>ReactJS, JavaScript, Redux, Bootstrap</span><br />
              <p style={{ textAlign: 'justify' }}><strong>TODOLIST </strong>adalah Aplikasi web to-do list adalah platform digital yang dirancang untuk membantu pengguna dalam mengelola dan mengatur tugas-tugas mereka secara efektif. </p>
              <br />
              Aplikasi ini mempermudah pengguna untuk:
              <ul>
                <li>- Menambah, mengedit, dan menghapus tugas</li>
                <li>- Menandai Tugas yang Selesai: Setelah menyelesaikan tugas, pengguna dapat menandainya sebagai selesai, yang akan secara otomatis memindahkannya dari daftar aktif ke daftar tugas yang selesai.</li>
              </ul><br />
            </>
          }
          websiteLink="https://superlative-bonbon-becc5a.netlify.app/" 
          websiteLink2="https://farah-todolist-app.netlify.app/" 
          src={pjkfor1}
          gallery={[pjkfor1, pjkfor2]} // Tambahkan gambar ke carousel
        />

        <ProjectsCard
          title={<span style={{ fontWeight: 'bold' }}>BMI kalkulator</span>}
          des={
            <>
              <span style={{ color: 'orange' }}>ReactJS, JavaScript, Redux, Bootstrap</span><br />
              <p style={{ textAlign: 'justify' }}><strong>Website kalkulator BMI (Body Mass Index) </strong> adalah platform digital yang dirancang untuk membantu pengguna menghitung dan memantau indeks massa tubuh mereka dengan mudah. </p>
              <br />
              Dengan menggunakan kalkulator BMI, pengguna dapat:
              <ul>
                <li style={{ textAlign: 'justify' }}><strong>Menghitung BMI:</strong> Pengguna dapat memasukkan data seperti berat badan (dalam kilogram) dan tinggi badan (dalam sentimeter atau meter) untuk menghitung indeks massa tubuh mereka secara otomatis. Kalkulator akan memberikan hasil BMI yang menunjukkan status kesehatan tubuh pengguna.</li>
                
              </ul><br /><br /><br /><br /><br /><br />
            </>
          }
          websiteLink="https://bmi-calculator-faraharyaresta.netlify.app/" 
          src={pjkfor3}
          gallery={[pjkfor3]} // Tambahkan gambar ke carousel
        />

        <ProjectsCard
          title={<span style={{ fontWeight: 'bold' }}>Website Desa Jatimakmur</span>}
          des={
            <>
              <span style={{ color: 'orange' }}>CodeIgniter 3, Bootstrap, MySQL</span><br />
              <p style={{ textAlign: 'justify' }}><strong>Website Desa Jatimakmur </strong>ini bertujuan untuk meningkatkan efisiensi pengelolaan data desa dan mempermudah interaksi antara warga desa dengan administrasi desa. Selain itu, website ini juga berfungsi untuk meningkatkan transparansi dan aksesibilitas informasi terkait layanan desa.</p>
              <br />
              Website ini memiliki dua peran utama, yaitu Admin dan Penduduk.:
              <ul style={{ textAlign: 'justify' }}>
                <li><strong>1. Admin: </strong>Memiliki hak akses untuk mengelola dan mengubah data penduduk yang terdaftar di desa. Admin dapat memperbarui informasi seperti nama, alamat, dan data lainnya untuk memastikan keakuratan data penduduk.</li><br/>
                <li><strong>2. Penduduk: </strong>Sebagai pengguna terdaftar, penduduk dapat mengajukan permintaan untuk memperoleh surat desa secara online. Hal ini memudahkan penduduk dalam mengakses dokumen yang diperlukan tanpa harus mengunjungi kantor desa secara langsung.</li>
                
              </ul><br />
            </>
          }
          githubLink="https://github.com/faraaryaresta/webdesa"
          websiteLink="https://portofolio-faraharyaresta.netlify.app/farah.epizy.com" 
          src={pjkfor4}
          gallery={[pjkfor4]} // Tambahkan gambar ke carousel
        />
        
      </div>
    </section>
  );
}

export default Projects;
